import React from 'react'
import { Trans } from '@lingui/react/macro'
import { MdOutlineSentimentDissatisfied } from 'react-icons/md'
import { Button, Card } from '@tecsinapse/cortex-react'

export const PageNotFound = () => (
  <div>
    <Card className={'flex flex-col space-y-centi items-center'}>
      <MdOutlineSentimentDissatisfied size={48} />
      <p className={'text-h1'}>404!</p>
      <Trans>
        <h3>
          Desculpe, mas a rota solicitada não existe. Tente acessar sua página a
          partir do menu.
        </h3>
      </Trans>
      <Button onClick={() => window.history.back()}>
        <Trans>Voltar</Trans>
      </Button>
    </Card>
  </div>
)
